import type { Dispatch } from "react";
import type { CommonEditorTab, EditorAction } from "../editor/reducers";
import { Icon } from "@mdi/react";
import { mdiClose } from "@mdi/js";
import { Button } from "@acdc2/ui/components/button";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@acdc2/ui/components/tooltip";

type Props = {
  dispatch: Dispatch<EditorAction>;
  parentTab?: CommonEditorTab;
};

export function NavbarTabCloseButton({
  dispatch,
  parentTab = "regions",
}: Props) {
  const { t } = useTranslation();

  const onClick = () => {
    dispatch({
      type: "switchToCommonTab",
      tab: parentTab,
    });
  };

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="outline" size="icon" onClick={onClick}>
            <Icon path={mdiClose} size="1.25rem" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          {t("NavbarTabCloseButton.tooltip")}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
